






































import { ResultMappingIdEnum } from '../../enums';

export default {
  name: 'result-mappings-card',
  props: {
    resultMappings: {
      type: Object,
      required: true
    }
  },
  data: function () {
    const imageMappings = [
      ResultMappingIdEnum.IMAGE_URL_PREFIX,
      ResultMappingIdEnum.IMAGE_URL
    ];
    return {
      imageMappings,
      mappings: Object.values(ResultMappingIdEnum).filter((mappingId: ResultMappingIdEnum) => (!imageMappings.includes(mappingId))),
      imageUrl: require('../../assets/media/image/image-not-found.svg'),
      messages: this.$epb.messages.tools.instances.fields.catalog.resultMappings,
      ResultMappingIdEnum
    };
  }
};
